import AppSetting from '../../common/constants/appsetting.constant';
// import Countries from 'src/app/common/constants/countries.constant';
import StorageType from '../session/storage.enum';
import StorageService from '../session/storage.service';
import axios from 'axios'

const RoleService = {

  loggedInUserData: {},

  roleList: [],

  getLoggedInData() {
    return JSON.parse(StorageService.get(StorageType.session, 'userDetails'));
  },

  find(reqObj) {
    let loggedInUserData = this.getLoggedInData();

    let url = '';
    if (reqObj.practiceId) {
      url = AppSetting.role.find.replace('{providerId}', reqObj.practiceId);
    }
    else {
      url = AppSetting.role.find.replace('{providerId}', loggedInUserData.parentId);
    }
    url = `${url}${this.buildQuery(reqObj)}`;

    return axios.get(url)
      .then(a => { return a })
      .catch(err => { return err })
  },
  getMasterRole() {
    let loggedInUserData = this.getLoggedInData();
    let url = AppSetting.role.masterRole
    return axios.get(url)
      .then(res => { return res })
      .catch(err => { return err })
  },

  getById(roleId, practiceId) {
    let loggedInUserData = this.getLoggedInData();
    if (!practiceId) practiceId = loggedInUserData.parentId;
    let url;

    if (!practiceId) {
      practiceId = loggedInUserData.parentId;
    }

    url = AppSetting.role.getById
      .replace('{providerId}', practiceId)
      .replace('{roleId}', roleId);

    return axios.get(url)
      .then(a => { return a })
      .catch(err => { return err })

  },

  add(reqObj, providerId) {
    let loggedInUserData = this.getLoggedInData();
    if (!providerId) providerId = loggedInUserData.parentId;
    let url = '';

    url = AppSetting.role.add
      .replace('{providerId}', providerId);

    return axios.post(url, reqObj)
      .then(a => { return a })
      .catch(err => { return err })
  },

  update(reqObj, roleId, providerId) {
    let loggedInUserData = this.getLoggedInData();
    if (!providerId) providerId = loggedInUserData.parentId;

    let url = '';
    url = AppSetting.role.edit
      .replace('{providerId}', providerId)
      .replace('{roleId}', roleId);

    return axios.put(url, reqObj)
      .then(a => { return a })
      .catch(err => { return err })
  },

  delete(roleId) { },




  activateRole(roleId, practiceId) {
    this.loggedInUserData = this.getLoggedInData();
    let url;

    url = AppSetting.role.activateDeactivateRole
      .replace('{parentId}', practiceId)
      .replace('{roleId}', roleId);

    return axios.post(url, {})
      .then(a => {return a})
      .catch(err=>{return err})
  },

  deactivateRole(roleId, practiceId) {
    this.loggedInUserData = this.getLoggedInData();
    let url;
    url = AppSetting.role.activateDeactivateRole
      .replace('{parentId}', practiceId)
      .replace('{roleId}', roleId);

    return axios.delete(url)
      .then(a => {return a})
      .catch(err=>{return err})
  },

  buildQuery(data) {
    let queryData = '';
    for (const prop in data) {
      if (data[prop] !== '' && data[prop] !== 'undefined' && data[prop] !== null && data[prop].length !== 0) {
        if (queryData === '') {
          queryData = '?' + prop + '=' + data[prop];
        } else {
          queryData += '&' + prop + '=' + data[prop];
        }
      }
    }
    return queryData;
  },

  roleLookup(reqObj) {

    this.loggedInUserData = this.getLoggedInData();
    let url = '';
    if (reqObj?.practiceId) {
      url = AppSetting.role.lookup
        .replace('{providerId}', reqObj.practiceId) + this.buildQuery(reqObj);
    }
    else {
      url = AppSetting.role.lookup
        .replace('{providerId}', this.getLoggedInData()['parentId']) + this.buildQuery(reqObj);
    }

    return axios.get(url)
      .then(data => data)
      .catch(err => {
        console.log(err)
      })
  },


}

export default RoleService